import {
  Plus, Eye, Braces, GitBranchPlus, RefreshCw,
  Download, Upload, FileUp, Pencil, Trash2,
} from 'lucide-react';
import type { ContextMenuItem } from '@/components/shared/ContextMenu';

export interface DatabaseActionDeps {
  onCreateTable: () => void;
  onCreateView: () => void;
  onCreateFunction: () => void;
  onViewERD: () => void;
  onReload: () => void;
  onBackup: () => void;
  onRestore: () => void;
  onImport: () => void;
  onEdit: () => void;
  onDrop: () => void;
}

/**
 * Build the canonical action list for a database node. Unlike connections or
 * tunnels there's no stateful toggle, so there is no featured primary card —
 * just grouped secondary actions.
 */
export function buildDatabaseActions(deps: DatabaseActionDeps): ContextMenuItem[] {
  return [
    { label: '', separator: true, sectionTitle: 'Create' },
    { label: 'Create Table…', icon: Plus, onClick: deps.onCreateTable },
    { label: 'Create View…', icon: Eye, onClick: deps.onCreateView },
    { label: 'Create Function…', icon: Braces, onClick: deps.onCreateFunction },

    { label: '', separator: true, sectionTitle: 'Operations' },
    { label: 'View ERD', icon: GitBranchPlus, onClick: deps.onViewERD },
    { label: 'Reload', icon: RefreshCw, onClick: deps.onReload },
    { label: 'Backup Database…', icon: Download, onClick: deps.onBackup },
    { label: 'Restore from SQL…', icon: Upload, onClick: deps.onRestore },
    { label: 'Import to New Table…', icon: FileUp, onClick: deps.onImport },

    { label: '', separator: true, sectionTitle: 'Manage' },
    { label: 'Edit Database…', icon: Pencil, onClick: deps.onEdit },

    { label: '', separator: true, sectionTitle: 'Danger Zone' },
    { label: 'Drop Database…', icon: Trash2, danger: true, onClick: deps.onDrop },
  ];
}
